// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zLGy","delete":"styles_delete__O8eto","update":"styles_update__2nQzp","add":"styles_add__3B9IS"};